import { ReactElement } from 'react'
import styled from 'styled-components'
import Badge from 'react-bootstrap/Badge'
import fonts from '../../../const/fonts'
import Button from 'react-bootstrap/esm/Button'
import Card from 'react-bootstrap/Card'
import CardWrapper from '../../../components/CardWrapper'

interface StatusMarkerProps {
  color: string
}

export const StatusMarkerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 24px;
`

export const TestWrapper = styled.div`
  display: flex;
  height: auto;
  flex-direction: column;
  width: 60%;
  border: 1px solid ${({ theme }) => theme.card.border};
  box-shadow: 0 1px 10px 0 ${({ theme }) => theme.card.border};
  border-radius: 10px;
  padding: 20px;
  margin-top: 28px;
  @media (max-width: 415px) {
    width: 100%;
    * > img {
      max-width: 280px;
    }
  }
`

export const StatusMarker = styled.div<StatusMarkerProps>`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 8px;
  margin-right: 12px;
  background: ${({ color }) => color};
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
`

export const InfoList = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  @media (max-width: 415px) {
    margin: 12px auto;
  }
  > * {
    margin: auto 8px;
  }
`

export const InfoBadge = styled(Badge)`
  display: block;
  max-width: 300px;
  min-width: 100px;
  height: 30px;
  padding: 8px;
  margin: auto 20px;
  font-size: ${fonts.tiny}px;
  @media (max-width: 415px) {
    margin: auto 4px;
  }
`

export const Section = styled(Button)`
  border-radius: 20px;
  margin: 0 20px;
`

export const TestSection = styled.div`
  display: flex;
  margin: 16px;
  flex-wrap: wrap;
  height: auto;
  justify-content: space-evenly;
`

export const JumpToQuestionsWrapper = styled.div`
  margin-top: 28px;
  width: 35%;
  @media (max-width: 415px) {
    width: 100%;
  }
`

export const JumpQuestionsList = styled(Card.Body)`
  padding: 16px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > * {
    margin: 6px;
    box-shadow: 0 1px 10px 0 ${({ theme }) => theme.card.border};
    width: 55px;
  }
`

const TrackerWrapper = styled(CardWrapper)`
  align-items: center;
  text-align: center;
  margin-top: 12px;
`

export const TestFooterWrapper = styled.div`
  margin: 32px auto;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  > * {
    margin: 12px;
  }
`

interface TrackerProps {
  title: string
  subTitle: string
}

export const Tracker = ({ title, subTitle }: TrackerProps): ReactElement => {
  return (
    <TrackerWrapper>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{subTitle}</Card.Text>
      </Card.Body>
    </TrackerWrapper>
  )
}
